import React from "react";
import InputWrapper from "../../general/InputWrapper";
import classes from "./RadioInput.module.css";

const RadioInput = ({
  title,
  desc_text,
  help_text,
  options,
  inputObject,
  fieldName,
  inputs,
  updateInput,
  errors = {},
}) => {
  const handleChange = (value) => {
    updateInput(inputObject, fieldName, value);
  };

  return (
    <InputWrapper
      title={title}
      desc_text={desc_text}
      help_text={help_text}
      error_text={errors[fieldName]}
    >
      <section className={classes.radio_container}>
        {options.map((option) => (
          <div
            className={classes.radio_input}
            key={`${fieldName}-${option.value}`}
          >
            <input
              type="radio"
              id={`${fieldName}-${option.value}`}
              name={fieldName}
              value={option.value}
              checked={inputs[inputObject][fieldName] === option.value}
              onChange={(e) => handleChange(e.target.value)}
            />
            <label htmlFor={`${fieldName}-${option.value}`}>
              {option.label}
            </label>
          </div>
        ))}
      </section>
    </InputWrapper>
  );
};

export default RadioInput;
